<template>
  <div class="contact page">
    <div class="page-header">
      <div class="container">
        <h1 class="title">{{ $t('pagetitle.contactus') }}</h1>
      </div>
    </div>
    <div class="page-body">
      <div class="container">
        <el-row class="subtitle">
          <span class="text">
            {{ $t('subtitle.contactmessage') }}
          </span>
        </el-row>
        <el-row type="flex" v-if="($mq.resize && $mq.above('769px'))">
          <el-col :span="9" class="contact-box">
            <div class="contact-person" v-for="(contact, index) in contacts" :key="index">
              <span class="text">{{ contact.name }}</span>
              <span class="text">{{ contact.number }}</span>
              <span class="text">{{ contact.email }}</span>
            </div>
          </el-col>
          <el-col :span="15" class="form-box">
            <el-form ref="form" :model="form" :rules="rules">
              <el-form-item prop="subject">
                <el-input :disabled="disable" :placeholder="$t('form.subject') + '*'" class="custom-input" v-model="form.subject"></el-input>
              </el-form-item>
              <el-form-item prop="message">
                <el-col :span="24">
                  <el-input :disabled="disable" :placeholder="$t('form.message') + '*'" type="textarea" v-model="form.message"
                  :autosize="{ minRows: 4, maxRows: 4}"></el-input>
                </el-col>
              </el-form-item>
              <!-- <el-form-item prop="image">
                <el-upload
                  action=""
                  :disabled="disable"
                  :auto-upload="false"
                  :on-change="handleChange"
                  :on-remove="handleRemove"
                  :before-upload="beforeAvatarUpload"
                  :limit="1"
                  :file-list="fileList">
                  <el-button class="upload-button" icon="el-icon-upload2" slot="trigger" size="small" type="primary">
                    select file
                  </el-button>
                  <div class="el-upload__tip" slot="tip">jpg/png files with a size less than 2MB.</div>
                </el-upload>
              </el-form-item> -->
              <el-form-item>
                <el-button :loading="loading" class="orange-button" @click="onSubmit">Submit</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-row class="mobile-form" type="flex" justify="center">
          <el-form v-if="($mq.resize && $mq.below('768px'))" ref="form" :model="form" :rules="rules">
            <el-form-item prop="subject">
              <el-input :disabled="disable" :placeholder="$t('form.subject') + '*'" class="custom-input" v-model="form.subject"></el-input>
            </el-form-item>
            <el-form-item prop="message">
              <el-input :disabled="disable" :placeholder="$t('form.message') + '*'" type="textarea" v-model="form.message"
              :autosize="{ minRows: 4, maxRows: 4}"></el-input>
            </el-form-item>
            <!-- <el-form-item prop="image">
              <el-upload
                class="upload-wrap"
                action=""
                :disabled="disable"
                :auto-upload="false"
                :on-change="handleChange"
                :on-remove="handleRemove"
                :before-upload="beforeAvatarUpload"
                :limit="1"
                :file-list="fileList">
                <el-button class="upload-button" icon="el-icon-upload2" slot="trigger" size="small" type="primary">
                  select file
                </el-button>
                <div class="el-upload__tip" slot="tip">jpg/png files with a size less than 2MB.</div>
              </el-upload>
            </el-form-item> -->
            <el-form-item class="center">
              <el-button :loading="loading" class="orange-button" @click="onSubmit">Submit</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row v-if="($mq.resize && $mq.below('768px'))" type="flex">
          <el-col class="contact-box">
            <div class="contact-person" v-for="(contact, index) in contacts" :key="index">
              <span class="text">{{ contact.name }}</span>
              <span class="text">{{ contact.number }}</span>
              <span class="text">{{ contact.email }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import Site from '@/api/site'
export default {
  name: 'faq',
  components: {
  },
  data () {
    return {
      fileList: [],
      form: {
        subject: '',
        message: ''
      },
      rules: {
        subject: [
          { required: true, message: 'Please input subject', trigger: 'blur' }
        ],
        message: [
          { required: true, message: 'Please input message', trigger: 'blur' },
          { min: 20, message: 'The message must have minimum 20 of characters', trigger: 'blur' }
        ]
      },
      contacts: [
        {
          name: 'Mili',
          number: '017-475-0795',
          email: 'mili@tapsgroup.com'
        },
        // {
        //   name: 'Brandon',
        //   number: '014-328-7282',
        //   email: 'brandon@tapsgroup.com'
        // },
        {
          name: 'Andy (Northern Region)',
          number: '016-557-1497',
          email: 'andy@tapsgroup.my'
        },
        // {
        //   name: 'Alexis (Off-Trade)',
        //   number: '016-603-3323',
        //   email: 'alexis@tapsgroup.my'
        // },
        {
          name: 'Nygel (Southern Region & Klang Valley)',
          number: '012-307-2907',
          email: 'nygel@tapsgroup.my'
        },
        {
          name: 'Adzul (Klang Valley)',
          number: '016-522-1785',
          email: 'adzul@tapsgroup.my'
        }
      ],
      disable: false,
      loading: false,
      fileObj: undefined
    }
  },
  mounted () {
  },
  methods: {
    handleChange (file, fileList) {
      if (file) {
        this.fileObj = {
          name: 'files[0]',
          raw: file.raw,
          filename: file.name
        }
      }
    },
    handleRemove (file, fileList) {
      this.fileObj = undefined
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG && !isPNG) {
        this.$message.error('Avatar picture must be JPG or PNG format!')
      }
      if (!isLt2M) {
        this.$message.error('Avatar picture size can not exceed 2MB!')
      }
      return (isJPG || isPNG) && isLt2M
    },
    onSubmit () {
      this.loading = true
      this.disable = true
      const data = this.generateData()
      Site.createMessage(data).then((res) => {
        this.reset()
        this.disable = false
        this.loading = false
        this.$message({
          message: 'Thank you for contacting us – we will get back to you soon!',
          type: 'success'
        })
      }).catch((err) => {
        this.disable = false
        this.loading = false
        console.log(err)
      })
    },
    generateData () {
      let formData = new FormData()
      if (this.fileObj) {
        formData.append(this.fileObj.name, this.fileObj.raw, this.fileObj.filename)
      }
      formData.append('subject', this.form.subject)
      formData.append('message', this.form.message)
      formData.append('userId', this.$store.getters.id)
      return formData
    },
    reset () {
      this.form = {
        subject: '',
        message: ''
      }
      this.fileList = []
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    }
  }
}
</script>
<style lang="scss">

</style>
<style lang="scss" scoped>
@import "@/styles/settings.scss";
.contact {
  .page-body {
    .container {
      padding: 50px 0;
    }
  }
  .contact-box {
    & > h1 {
      margin-bottom: 25px;
    }
    & > img {
      width: 100px;
    }
  }
  .upload-wrap {
    display: flex;
    justify-content: center;
    flex-direction: column;
    .el-upload__tip {
      display: flex;
      justify-content: center;
    }
  }

  .subtitle {
    padding-bottom: 50px;
  }

  .contact-person {
    margin-bottom: 20px;
    .text {
      display: block;
    }
  }
  .mobile-form {
    // padding-top: 25px;
    .el-form {
      width: 100%;

      & .center {
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/contact/index.vue